import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {push} from 'connected-react-router';
import {NavLink, withRouter} from 'react-router-dom';
import moment from 'moment';
import 'moment-timezone';
import 'moment/locale/ru';

import * as action from '../../actions';
import * as selector from '../../selectors';

const mapStateToProps = (state, ownProps) => {
	return {
		today: !ownProps.match.params.date,
		settings: selector.getSettings(state),
		momentTimezoneOffset: selector.getMomentTimezoneOffset(state),
	};
};
const mapDispatchToProps = dispatch => {
	return bindActionCreators({
		loadBookings: action.loadBookings.request,
		unselectAll: action.unselectAll,
		push,
	}, dispatch);
};

@withRouter
@connect(mapStateToProps, mapDispatchToProps)
export default class extends Component {
	static propTypes = {
		today: PropTypes.bool,
		date: PropTypes.string,
		loadBookings: PropTypes.func,
		unselectAll: PropTypes.func,
		push: PropTypes.func,
		settings: PropTypes.object,
		momentTimezoneOffset: PropTypes.object,
	}

	componentWillMount() {
		const {
			today,
			date,
			settings: {timezone},
			momentTimezoneOffset,
			push
		} = this.props;

		// редирект со старой даты
		if (!today) {
			const day = moment.tz(date, timezone);
			const day1 = momentTimezoneOffset.startOf('day');
			const dayN = day1.clone().add({days: 7});

			if (!day.isBetween(day1, dayN, null, '[)')) {
				push({pathname: '/book'});
				setTimeout(() => {
					this.props.loadBookings({date: momentTimezoneOffset.format('YYYY-MM-DD')});
				}, 500);
			}
		}
	}

	onSelectDate = event => {
		const {
			momentTimezoneOffset,
			push
		} = this.props;
		const date = event.target.value;

		this.updateTable(date);

		const todayDate = momentTimezoneOffset.format('YYYY-MM-DD');
		if (todayDate === date) {
			push({pathname: `/book`});
		} else {
			push({pathname: `/book/${date}`});
		}
	};

	updateTable = date => {
		this.props.unselectAll();
		this.props.loadBookings({date});
	}

	render() {
		const {
			momentTimezoneOffset,
		} = this.props;

		let dates = [];
		for (let i=0; i<7; i++) {
			dates.push(momentTimezoneOffset.clone().add({days: i}));
		}

		const today = momentTimezoneOffset.clone();
		const tomorrow = momentTimezoneOffset.clone().add({days: 1});

		return (
			<div className="tools">
				<div className="row">
					<div className="col-6 col-lg-3">
						<NavLink exact
							to="/book"
							className="btn btn-block btn-outline-secondary custom-border-active custom-color-active"
							onClick={() => this.updateTable(today.format('YYYY-MM-DD'))}
						>
							Сегодня<span className="d-none d-sm-inline">{today.format(' (D MMMM)')}</span>
						</NavLink>
					</div>
					<div className="col-6 col-lg-3">
						<NavLink
							to={`/book/${tomorrow.format('YYYY-MM-DD')}`}
							className="btn btn-block btn-outline-secondary custom-border-active custom-color-active"
							onClick={() => this.updateTable(tomorrow.format('YYYY-MM-DD'))}
						>
							Завтра<span className="d-none d-sm-inline">{tomorrow.format(' (D MMMM)')}</span>
						</NavLink>
					</div>
					<div className="col-md-6 col-lg-2 text-right other-date">
						<label htmlFor="other-date" className="form-control-plaintext">Другая дата:</label>
					</div>
					<div className="col-md-6 col-lg-4">
						<select className="form-control" name="date" id="other-date" onChange={this.onSelectDate} value={this.props.date}>
							{dates.map((date, i) => (
								<option key={i} value={date.format('YYYY-MM-DD')}>{date.format('dddd (D MMMM)')}</option>
							))}
						</select>
					</div>
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/book/BookTools.js